module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_4@2x.70938fb.jpg";